
// Functions for creating UI elements in the BlockStack game
import { GAME_CONFIG } from '../gameConfig';

// Helper to get appropriate font size based on screen size
function getFontSize(isMobile = false) {
  return isMobile ? '16px' : '20px';
}

// Create UI elements with mobile optimization
export function createUI(scene) {
  // Detect if the game is running on a mobile device
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  
  // Adjust positions for better mobile layout
  const xPosition = isMobile ? 
    GAME_CONFIG.boardWidth * GAME_CONFIG.blockSize + 10 : 
    GAME_CONFIG.boardWidth * GAME_CONFIG.blockSize + 20;
  
  // Create container for UI elements
  const ui = {
    scoreText: scene.add.text(
      xPosition, 
      50, 
      'Score: 0', 
      { 
        fontSize: getFontSize(isMobile), 
        fill: '#ffffff',
        fontFamily: 'Arial, sans-serif'
      }
    ),
    levelText: scene.add.text(
      xPosition, 
      isMobile ? 80 : 90, 
      'Level: 1', 
      { 
        fontSize: getFontSize(isMobile), 
        fill: '#ffffff',
        fontFamily: 'Arial, sans-serif'
      }
    ),
    linesText: scene.add.text(
      xPosition, 
      isMobile ? 110 : 130, 
      'Lines: 0', 
      { 
        fontSize: getFontSize(isMobile), 
        fill: '#ffffff',
        fontFamily: 'Arial, sans-serif'
      }
    )
  };
  
  // Add touch controls hint for mobile only
  if (isMobile) {
    ui.touchHint = scene.add.text(
      xPosition,
      160,
      'Tap to control',
      {
        fontSize: '14px',
        fill: '#ffffff',
        fontFamily: 'Arial, sans-serif'
      }
    );
  }
  
  return ui;
}

// Create game over display with mobile optimization
export function createGameOverDisplay(scene) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const centerX = scene.game.config.width / 2;
  const centerY = scene.game.config.height / 2;
  
  const overlay = scene.add.rectangle(
    centerX,
    centerY,
    scene.game.config.width,
    scene.game.config.height,
    0x000000,
    0.7
  );
  
  const gameOverText = scene.add.text(
    centerX,
    centerY - 50,
    'GAME OVER',
    {
      fontSize: isMobile ? '32px' : '48px',
      fill: '#ffffff',
      fontFamily: 'Arial, sans-serif'
    }
  );
  gameOverText.setOrigin(0.5);
  
  const restartText = scene.add.text(
    centerX,
    centerY + 50,
    isMobile ? 'Tap to restart' : 'Press any key to restart',
    {
      fontSize: isMobile ? '18px' : '24px',
      fill: '#ffffff',
      fontFamily: 'Arial, sans-serif'
    }
  );
  restartText.setOrigin(0.5);
  
  return { overlay, gameOverText, restartText };
}

// Create pause display with mobile optimization
export function createPauseDisplay(scene) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const centerX = scene.game.config.width / 2;
  const centerY = scene.game.config.height / 2;
  
  const overlay = scene.add.rectangle(
    centerX,
    centerY,
    scene.game.config.width,
    scene.game.config.height,
    0x000000,
    0.7
  );
  
  const pausedText = scene.add.text(
    centerX,
    centerY,
    'PAUSED',
    {
      fontSize: isMobile ? '32px' : '48px',
      fill: '#ffffff',
      fontFamily: 'Arial, sans-serif'
    }
  );
  pausedText.setOrigin(0.5);
  
  return { overlay, pausedText };
}
